import type { RouteRecordRaw } from "vue-router"
import PageBuildingData from "./pages/PageBuildingData.vue"

export const buildingShellChildren = [
    {
        path: "data",
        name: "PageBuildingData",
        component: PageBuildingData,
    },
] as RouteRecordRaw[]
